import React from "react";
import { Dropdown, Checkbox } from "semantic-ui-react";
import HorizontalOrder from "./HorizontalOrder";

class MultipleSelect extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			openOrder: false,
			searchQuery: "",
			options: props.factory.list
				? props.factory.list.map((value) => {
						return {
							key: value.id,
							text: (value.name ? value.name : value.code) + (value.label ? `(${value.label})` : ""),
							value: JSON.stringify(value),
						};
				  })
				: [],
		};
	}

	update = (value) => {
		this.props.update(value);
		this.setState({ value: value, searchQuery: "" });
	};

	handleSearchChange = (e, { searchQuery }) => this.setState({ searchQuery });
	render() {
		const { factory } = this.props;
		return (
			<div style={styles.multipleSelectContainer}>
				<div style={styles.containerInput}>
					<div style={styles.label}>{factory.selectedLabel}</div>
					<div style={styles.inputGroup}>
						<Dropdown
							options={this.state.options}
							name={this.props.key}
							placeholder={factory.listLabel}
							fluid
							multiple
							selection
							search
							deburr
							searchQuery={this.state.searchQuery}
							noResultsMessage={null}
							value={factory.value}
							onChange={(e, { value }) => this.update(value)}
							onSearchChange={this.handleSearchChange}
						/>
						{this.props.order && factory.value && factory.value.length > 0 ? (
							<Checkbox
								style={{ margin: "6px" }}
								toggle
								onChange={() => {
									this.setState((prevState) => ({ openOrder: !prevState.openOrder }));
								}}
								checked={this.state.openOrder}
							/>
						) : null}
					</div>
				</div>
				{this.state.openOrder && this.props.order && factory.value && factory.value.length > 0 ? (
					<div style={{ marginTop: "1vh" }}>
						<HorizontalOrder update={this.update} data={factory.value} />
					</div>
				) : null}
			</div>
		);
	}
}

const styles = {
	containerInput: {
		width: "100%",
		display: "flex",
		flexDirection: "column",
	},
	inputGroup: {
		alignItems: "center",
		display: "flex",
	},
	multipleSelectContainer: {
		width: "100%",
		marginBottom: "1vh",
		marginTop: "2vh",
	},
	label: {
		fontWeight: "600",
		marginBottom: "0.5vh",
	},
};

export default MultipleSelect;
